import { MouseEventHandler } from "react";

import { ArrowRight } from "../../../components";

import Link from "./HeaderTabLink.styles";

type HeaderTabLinkProps = {
    url?: string;
    text?: string;
    ariaLabel?: string;
    onClick?: MouseEventHandler;
    tabIndex?: number;
};

const HeaderTabLink = ({
    url,
    text,
    ariaLabel,
    onClick,
    tabIndex
}: HeaderTabLinkProps) => {
    return (
        <Link
            href={url}
            aria-label={ariaLabel}
            onClick={onClick}
            tabIndex={tabIndex}
        >
            {text}
            <ArrowRight color="B300" />
        </Link>
    );
};

export default HeaderTabLink;
